import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  appBar: {
    height: '35px',
    background: '#fafafa',
    position: 'relative',
    borderBottom: '3px solid #DF0C36',
    marginTop: '16px',
    zIndex: 0,
  },
  buttonGroup: {
    height: '32px',
    boxShadow: 'none',
  },
  selectedTab: {
    textTransform: 'none',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    color: '#FFFFFF',
    lineHeight: '20px',
    background: '#DF0C36',
    width: 'fit-content',
    whiteSpace: 'nowrap',
    borderRadius: 0,
    '&:hover': {
      backgroundColor: '#DF0C36',
    },
  },
  notSelectedTab: {
    textTransform: 'none',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    color: '#333333',
    lineHeight: '20px',
    background: '#FFFFFF',
    width: 'fit-content',
    whiteSpace: 'nowrap',
    borderRadius: 0,
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
  },
}));
